// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__VXaEW","footer":"ModalInfo_footer__2agME"};